// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorBody_container__3CD3c","scrollableMessage":"ErrorBody_scrollableMessage__1MElN","btn":"ErrorBody_btn__2A_p6"};